import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { isNullOrEmpty } from "../Utils/TextUtils";
import { CustomError } from "./Toast";
import { useNavigate } from "react-router-dom";
import MapView from "./MapView";
import { useDispatch, useSelector } from "react-redux";
import { setUserLocation } from "../Redux/Action";

const MapViewModal = ({ setGenderPopupVisibilityPopup }) => {
  const userLocation = useSelector((state) => state.userLocation);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const disableScrollOnOpen = () => {
    document.body.style.overflow = "hidden";
  };
  const disableScrollOnClose = () => {
    document.body.style.overflow = "auto";
  };

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [lat, setLat] = useState(
    localStorage.getItem("lat")
      ? parseFloat(localStorage.getItem("lat"))
      : userLocation
      ? userLocation.location?.lat
      : 21.3891
  );
  const [lng, setLng] = useState(
    localStorage.getItem("lng")
      ? parseFloat(localStorage.getItem("lng"))
      : userLocation
      ? userLocation.location?.lng
      : 39.8579
  );

  //#region localization code

  let [isArabic, setIsArabic] = useState(
    i18n.resolvedLanguage == "ar" ? true : false
  );
  useEffect(() => {
    if (i18n.resolvedLanguage == "en") {
      setIsArabic((isArabic = false));
    } else {
      setIsArabic((isArabic = true));
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  const onPickLocation = (lati, long) => {
    setLat(lati);
    setLng(long);
    localStorage.setItem("lat", lati);
    localStorage.setItem("lng", long);
    let location = {
      lat: lati,
      lng: long,
    };
    dispatch(setUserLocation(location));
  };

  return (
    <>
      <Modal
        onAfterOpen={disableScrollOnOpen}
        onAfterClose={disableScrollOnClose}
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={false}
        onRequestClose={() => {
          setIsModalOpen(false);
        }}
        // style={customStyles}
        className="Branch_Modal"
        overlayClassName="Branch_Overlay"
      >
        <div
          className="Pop_Select_Branch_Text_Style"
          style={{ marginBottom: 0 }}
        >
          {t("chose_loc")}
        </div>
        <div style={{ padding: "0em 2em" }}>
          <MapView onPickLocation={onPickLocation} />
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="continue__btn"
            onClick={() => {
              debugger;
              if (isNullOrEmpty(lat) || isNullOrEmpty(lng))
                CustomError(t("err_add"));
              else {
                localStorage.setItem("type", 2);
                navigate("/home");
              }
            }}
          >
            {t("cntnue")}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default MapViewModal;
